import { useEffect, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import dayjs from 'dayjs'
import styled from "styled-components"
import PatronCategoriesForm from '../../views/BackStage/PatronCategoriesForm'
import { useMessageType } from '../../controllers/MessageTypeController'
import { usePatronCategory } from "../../controllers/PatronCategoryController"
import { Row, Col } from '../../../ui/RowCol'
import { Toaster, toast } from 'sonner'
import { Button } from "../../../ui/button"

const NewOrEditPatronCategory = () => {
    const thisJS = "NewPatronCategory"
    const navigate = useNavigate()
    const { categorycode } = useParams()
    const bIsPostMode = categorycode === "0"
    const bIsPatchMode = !bIsPostMode && categorycode.length > 0
    const formRef = useRef()
    const [modalLoading, setModalLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState(bIsPostMode ? "post" : (bIsPatchMode ? "patch" : "get"))

    const onFormFinish = (values) => {
        console.log(thisJS, "onFormFinish", axiosMode, values)
        if (axiosMode === "get") { return; }
        if (bIsPostMode) {
            postPatronCategoryData([{ ...values }])
        } else if (bIsPatchMode) {
            patchPatronCategoryData([{ ...values }])
        }
    }
    const {
        PatronCategoryData,
        getPatronCategoryData,
        postPatronCategoryData,
        patchPatronCategoryData
    } = usePatronCategory({
        onBefore: ({ axiosMode, values }) => {
            console.log(thisJS, "PatronCategoryData", axiosMode, "onBefore", values)
            const bIsGet = axiosMode === "get"
            if (!bIsGet) { setModalLoading(true) }
        },
        onFinish: ({ axiosMode, status, values }) => {
            console.log(thisJS, "PatronCategoryData", axiosMode, "onFinish", status, values)
            const bIsPost = axiosMode === "post"
            const bIsPatch = axiosMode === "patch"
            if (bIsPost || bIsPatch) {
                const cMode = bIsPost ? "新增" : "修改"
                if (status === "success") {
                    toast.success(cMode + "成功");
                    getPatronCategoryData({
                        categorycode
                    })
                        .then((response) => {
                            let datas = response?.data
                            let firstData = datas.find((ele) => true) || []
                            formRef.current.setValues(firstData)
                        })
                } else {
                    toast.error(cMode + "失敗");
                }
                setModalLoading(false)
            }
        }
    })
    const {
        MessageTypeData,
        getMessageTypeData
    } = useMessageType({
        onBefore: ({ axiosMode, values }) => { },
        onFinish: ({ axiosMode, status, values }) => { }
    })
    useEffect(() => {
        console.log({ categorycode })
        if (bIsPostMode) {
            setAxiosMode('post')
            getMessageTypeData({ categorycode: categorycode })
                .then((response) => {
                    let aMessage = response?.data
                    let defaultValue = {}
                    //defaultValue["branches"] = [{ "value": "NKNU", "label": "介壽校區" } ]
                    defaultValue["message"] = aMessage
                    console.log(thisJS, "PatronCategoryData", axiosMode, "useEffect", defaultValue)
                    formRef.current.setValues(defaultValue)
                })
        }
        if (bIsPatchMode) {
            setAxiosMode('patch')
            getPatronCategoryData({
                categorycode: categorycode
            })
                .then((response) => {
                    let datas = response?.data
                    let firstData = datas.find((ele) => true)
                    let defaultValue = {}
                    let intKeys = ['password_expiry_days', 'upperagelimit', 'dateofbirthrequired', 'enrolmentfee', 'reservefee', 'min_password_length', 'message', 'enrolmentperioddate', 'reset_password', 'branches']

                    Object.keys(firstData).forEach((key) => {
                        if (key === "branches") {
                            if (firstData[key] === "") {
                                defaultValue[key] = []
                                defaultValue['branches'] = []
                            }
                            else {
                                let branchesArr = firstData[key].map((val) => {
                                    return {
                                        label: val?.branchname,
                                        value: val?.branchcode,
                                    }
                                })
                                defaultValue['branches'] = branchesArr
                            }
                        }
                        else if (intKeys.includes(key)) {
                            defaultValue[key] = !!firstData[key] || firstData[key] === 0 ? firstData[key] : undefined
                        }
                        else {
                            defaultValue[key] = !!firstData[key] || firstData[key] === 0 ? `${firstData[key]}` : ''
                        }
                    })
                    console.log(thisJS, "PatronCategoryData", axiosMode, "useEffect", defaultValue)
                    formRef.current.setValues(defaultValue)
                })
        }
    }, [])
    return (
        <Row>
            <Toaster
                richColors
                position="top-center"

            />
            <Col span={24}>
                <Title>
                    {axiosMode === "post" && <>新增讀者類型</>}
                    {axiosMode === "patch" && <>修改讀者類型</>}
                </Title>
            </Col>
            <Col span={24}>
                <Row justify="end">
                    <Col>
                        <ButtonGroup>
                            <Button
                                onClick={() => {
                                    formRef.current.onFormSubmit()
                                }} >
                                儲存
                            </Button>
                            <Button
                                variant="ghost"
                                onClick={() => {
                                    navigate('/library/backstage/PatronCategories')
                                }}
                            >
                                取消</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <PatronCategoriesForm
                    ref={formRef}
                    onFormFinish={onFormFinish}

                />
            </Col>
        </Row>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const FlexBox = styled.div`
display: flex;
gap: 1em;
`

const VerticalBox = styled.div`
display: flex;
gap: 1em;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const PScontext = styled.div`
font-size: 0.8em;
color: #707070;
text-wrap: nowrap;
align-self: center;

`

const SmallFlexBox = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const ColumnFlexBox = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em10 = styled.div`
width: 10em;
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em20 = styled.div`
width: 20em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

export default NewOrEditPatronCategory